<template>
  <div class="sys-container">
    <div class="systemSetting">
      <div class="header">
        <div class="title_icg">
          <i class="iconfont el-icon-setting"></i><span>{{ $t("ems.systemSettings") }}</span
          ><span v-if="version !== ''" style="font-weight: lighter; margin-left: 40px; font-size: 14px">{{ $t("ems.currentVersion") }}: {{ version }}</span>
        </div>
        <div class="close" @click="close"><i class="iconfont icon-guanbi"></i></div>
      </div>
      <div class="mainContainer" :style="{ opacity: opacity }">
        <div class="nav">
          <div :class="{ navItem: true, active: active === 2 }" @click="openWin(2)">
            <i class="iconfont icon-gerenxinxi" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
            <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
              <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.ElectricLoad')" placement="top-start">
                <span>{{ $t("ems.personalInformation") }}</span>
              </el-tooltip>
            </div>
          </div>
          <div :class="{ navItem: true, active: active === 0 }" @click="openWin(0)" v-if="isAdmin">
            <i class="iconfont icon-yonghuguanli" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
            <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
              <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.ElectricLoad')" placement="top-start">
                <span>{{ $t("ems.UserManagement") }}</span>
              </el-tooltip>
            </div>
          </div>
          <div :class="{ navItem: true, active: active === 3 }" @click="openWin(3)" v-if="isAdmin">
            <i class="iconfont el-icon-setting" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
            <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
              <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.ElectricLoad')" placement="top-start">
                <span>{{ $t("ems.basicConfiguration") }}</span>
              </el-tooltip>
            </div>
          </div>
          <div :class="{ navItem: true, active: active === 4 }" @click="openWin(4)" v-if="isAdmin">
            <i class="iconfont el-icon-setting" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
            <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
              <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.ElectricLoad')" placement="top-start">
                <span>{{ $t("ems.SystemConfiguration") }}</span>
              </el-tooltip>
            </div>
          </div>
          <div :class="{ navItem: true, active: active === 5 }" @click="openWin(5)" v-if="isAdmin && isShowDataSource">
            <i class="iconfont icon-peibishujuku" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
            <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
              <span>{{ $t("ems.dataBackup") }}</span>
            </div>
          </div>
          <div :class="{ navItem: true, active: active === 6 }" @click="openWin(6)" v-if="isAdmin && alarmwxWorkSend">
            <i class="iconfont icon-jianzhuanquan-" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
            <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
              <span>{{ $t("systemSetting.alarmMessage") }}</span>
            </div>
          </div>
          <div v-if="isDevelop">
            <div :class="{ navItem: true, active: active === 7 }" @click="openWin(7)">
              <i class="iconfont icon-shujudaochu" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
              <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
                <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.tagManage')" placement="top-start">
                  <span>{{ $t("ems.tagManage") }}</span>
                </el-tooltip>
              </div>
            </div>
            <div :class="{ navItem: true, active: active === 8 }" @click="openWin(8)">
              <i class="iconfont el-icon-setting" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
              <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
                <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('systemSetting.dySetting')" placement="top-start">
                  <span>{{ $t("systemSetting.dySetting") }}</span>
                </el-tooltip>
              </div>
            </div>
            <div :class="{ navItem: true, active: active === 9 }" @click="openWin(9)">
              <i class="iconfont el-icon-setting" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
              <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
                <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('systemSetting.configMaintain')" placement="top-start">
                  <span>{{ $t("systemSetting.configMaintain") }}</span>
                </el-tooltip>
              </div>
            </div>
            <div :class="{ navItem: true, active: active === 10 }" @click="openWin(10)">
              <i class="iconfont el-icon-setting" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
              <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
                <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('systemSetting.subsystemMaintain')" placement="top-start">
                  <span>{{ $t("systemSetting.subsystemMaintain") }}</span>
                </el-tooltip>
              </div>
            </div>
            <div :class="{ navItem: true, active: active === 11 }" @click="openWin(11)">
              <i class="iconfont el-icon-setting" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
              <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
                <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('systemSetting.equipmentDay')" placement="top-start">
                  <span>{{ $t("systemSetting.equipmentDay") }}</span>
                </el-tooltip>
              </div>
            </div>
            <div :class="{ navItem: true, active: active === 12 }" @click="openWin(12)">
              <i class="iconfont el-icon-setting" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
              <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
                <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('systemSetting.equipmentManage')" placement="top-start">
                  <span>{{ $t("systemSetting.equipmentManage") }}</span>
                </el-tooltip>
              </div>
            </div>
            <div :class="{ navItem: true, active: active === 13 }" @click="openWin(13)">
              <i class="iconfont el-icon-setting" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
              <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
                <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('systemSetting.alarmTemplate')" placement="top-start">
                  <span>{{ $t("systemSetting.alarmTemplate") }}</span>
                </el-tooltip>
              </div>
            </div>
            <div :class="{ navItem: true, active: active === 14 }" @click="openWin(14)">
              <i class="iconfont el-icon-setting" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
              <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
                <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('systemSetting.developmentAlarm')" placement="top-start">
                  <span>{{ $t("systemSetting.developmentAlarm") }}</span>
                </el-tooltip>
              </div>
            </div>
            <div :class="{ navItem: true, active: active === 15 }" @click="openWin(15)">
              <i class="iconfont el-icon-setting" v-bind:style="{ margin: language === 'en' ? '3px 15px 0px 15px' : '' }"></i>
              <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '', fontSize: language === 'en' ? '20px' : '' }">
                <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('systemSetting.developmentAlarm')" placement="top-start">
                  <span>{{ $t("systemSetting.updatePage") }}</span>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="main">
          <transition name="fade">
            <UserManage v-if="active == 0"></UserManage>
            <StationInfo v-if="active == 1"></StationInfo>
            <PersonalInfo v-if="active == 2"></PersonalInfo>
            <SysIcon v-if="active == 3"></SysIcon>
            <SysSet v-if="active == 4"></SysSet>
            <SysDataSource v-if="active == 5"></SysDataSource>
            <AlarmMessageSet v-if="active == 6"></AlarmMessageSet>
            <TAGSys v-if="active == 7"></TAGSys>
            <RingCards v-if="active == 8"></RingCards>
            <SysAdminSet v-if="active == 9"></SysAdminSet>
            <Subsystem v-if="active == 10"></Subsystem>
            <ContainerSet v-if="active == 11"></ContainerSet>
            <DeviceManage v-if="active == 12"></DeviceManage>
            <alarmTemplateManage v-if="active == 13"></alarmTemplateManage>
            <DevAlarmSys v-if="active == 14"></DevAlarmSys>
            <UpdatePageSys v-if="active == 15"></UpdatePageSys>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import  {setStore, getStore} from "@/utils/store";
import { mapGetters } from "vuex";
import PersonalInfo from "./personalInfo";
import StationInfo from "./stationInfo";
import UserManage from "./userManage";
import SysIcon from "./sysIcon";
import SysSet from "./sysSet";
import SysDataSource from "./sysDataSource";
import AlarmMessageSet from "./alarmMessageSet";
import TAGSys from "./TAGSys";
import RingCards from "./ringCards";
import Subsystem from "./subsystem";
import SysAdminSet from "./sysAdminSet";
import ContainerSet from "./containerSet";
import DeviceManage from "./deviceManage";
import alarmTemplateManage from "./alarmTemplateManage";
import DevAlarmSys from "./DevAlarmSys";
import UpdatePageSys from "./UpdatePageSys";


import { setStore, getStore } from "@/utils/store";
import { getSysConfig } from "@/api/spms";

export default {
  name: "index",
  components: { PersonalInfo, StationInfo, UserManage, SysIcon, SysSet, SysDataSource, AlarmMessageSet, TAGSys, RingCards, SysAdminSet, Subsystem, ContainerSet, DeviceManage, alarmTemplateManage, DevAlarmSys, UpdatePageSys },
  inject: ["getUserInfo"],
  data() {
    return {
      active: 2,
      opacity: 0,
      isRouterAlive: true,
      isAdmin: false,
      isShowDataSource: false,
      version: "",
      alarmwxWorkSend: false,
      isDevelop: false,
    };
  },
  computed: {
    ...mapGetters(["language"]),
  },
  mounted() {
    setTimeout(() => {
      this.opacity = 1;
    }, 500);
    const user = this.getUserInfo();
    this.isAdmin = user.role_name && user.role_name.includes("admin");
    this.isDevelop = user.account && user.account.includes("develop");
    if (this.isDevelop) {
      this.isAdmin = true;
    }
    this.isShowDataSource = user.detail && user.detail.systemBackup == 1;
    this.alarmwxWorkSend = user.detail && user.detail.alarmWxWorkSend == 1;
    this.version = getStore({ name: "version" }) || "";
  },
  methods: {
    close() {
      this.$parent.sysVis = false;
    },
    openWin(index) {
      this.active = index;
    },
    reloadWin() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    saveSysConfig() {
      getSysConfig().then((res) => {
        this.form = res.data.data;
        setStore({
          name: "systemSet",
          content: res.data.data,
          type: "session",
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/site";
.fade-enter-active .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.sys-container {
  height: calc(100% - 100px);
  width: 100%;
  overflow: hidden;
  position: absolute;
  top: 100px;
  left: 0;
  z-index: 1000;
}
.systemSetting {
  margin-top: 10px;
  margin-right: 10px;
  margin-left: 10px;
  height: calc(100% - 20px);
  background-color: var(--header_bg);
  border: #595959 solid 1px;

  .header {
    width: 100%;
    height: 40px;
    background-color: var(--site_exend_header);
    position: relative;

    .title_icg {
      height: 100%;
      margin-left: 10px;
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: bold;
      color: #6da2ee;
      i {
        font-size: 22px;
        margin-right: 5px;
      }
    }
    .close {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      i {
        font-size: 20px;
        color: var(--input_font);
      }
    }
  }
  .mainContainer {
    width: 100%;
    height: calc(100% - 40px);
    background-color: var(--header_bg);
    display: flex;
    transition: all 0.5s linear;
    .nav {
      width: 320px;
      margin: 12px;
      background-color: var(--nav);
      padding: 10px 0;
      .navItem {
        height: 60px;
        color: var(--nav_title);
        display: flex;
        align-items: center;
        cursor: pointer;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        transition: all 0.3s linear;
        i {
          font-size: 28px;
          margin: 3px 30px 0;
        }
        .title {
          letter-spacing: 3px;
          font-size: 22px;
          // width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .navItem:hover {
        color: var(--fontblue);
      }
      .active {
        color: var(--fontblue);
      }
    }

    .main {
      flex: 1;
      margin: 12px 12px 12px 0;
      background-color: var(--nav);
      overflow: hidden;
    }
  }
}
</style>
